import { render, staticRenderFns } from "./ClvModalCloverParams.vue?vue&type=template&id=c3c8e3bc&"
import script from "./ClvModalCloverParams.vue?vue&type=script&lang=js&"
export * from "./ClvModalCloverParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports